import { DependencyList, Dispatch, SetStateAction, useEffect } from 'react';

export const useUpdateStateEffect = <T>(setState: Dispatch<SetStateAction<T>>, data: T, deps: DependencyList) =>
  useEffect(() => setState(data), deps);
